import React from "react";
export const Tick: React.FC<any> = () => (
	<g stroke="none" strokeWidth="1" fill="#B88B19" fillRule="evenodd">
		<polygon
			fillRule="nonzero"
			points="3.69828392 9.5546292 0 13.6665208 9.85004054 22.9166666 26 3.63086194 21.8473618 0 9.3789885 14.8893632"
		></polygon>
	</g>
);
